import {
  CheckListType,
  CompanyId,
} from "features/CenterContent/RoleContent/VehicleChecklist/utils";
import { dateTimeSchemaForm } from "shared/form/dateTimeSchema";
import { z } from "zod";

export const checklistFormSchema = z.object({
  dateTime: dateTimeSchemaForm,
  comment: z
    .string({ error: () => "Kommentar med årsak må fylles ut" })
    .min(1, "Kommentar med årsak må fylles ut"),
  executor: z
    .string({ error: () => "Kvittert av må fylles ut" })
    .min(1, "Kvittert av må fylles ut"),
  fillOutType: z
    .custom<CheckListType>()
    .refine((elem) => elem, "Velg type kvittering"),
  rollingStockId: z
    .string({ error: () => "Kjøretøy må fylles ut" })
    .min(1, "Kjøretøy må fylles ut"),
  vehicleType: z
    .string({ error: () => "Kjøretøytype må fylles ut" })
    .min(1, "Kjøretøytype må fylles ut"),
  trainOwner: z.custom<CompanyId>().refine((elem) => elem, "Velg selskap"),
});

export type ChecklistFormData = z.infer<typeof checklistFormSchema>;
